import { z } from 'zod';
import { zDbId } from '~/plugins/zod/utils';
import { CurrencyCodeSchema } from '../_types';
import { getFullName } from '~/utils/userUtils';
import { ItemType, OrderState } from '~/enums/_types';
import { LocaleSchema } from '~/plugins/i18n/_types';

// @plachtova: models are in special file because we had circular dependency problem
export const LanguageCodeSchema = z.string().length(2);
export const CountryCodeSchema = z.string().length(2);
export const LocalizedValueSchema = z.record(LocaleSchema.or(z.string()), z.string());
export const LocalizedArraySchema = z.record(LocaleSchema.or(z.string()), z.string().array());

export const AppUserSimpleSchema = z
    .object({
        Id: zDbId(),
        FirstName: z.string(),
        LastName: z.string(),
        Email: z.string().email(),
        Login: z.string(),
    })
    .transform((val) => ({
        ...val,
        FullName: getFullName(val),
    }));

export const PartnerSimpleSchema = z.object({
    Id: zDbId(),
    CardName: z.string(),
});

export const OrderLinkSchema = z.object({
    Id: zDbId(),
    DocumentNumber: z.number().nullable(),
    Status: z.nativeEnum(OrderState),
});

export const PriceSchema = z.object({
    Value: z.number(),
    Currency: CurrencyCodeSchema,
});

export const CategorySimpleSchema = z.object({
    Id: zDbId(),
    Name: z.string(),
});

export const CategoryItemDetailSchema = z.object({
    Id: zDbId(),
    Code: z.string(),
    Name: z.string(),
    Category: CategorySimpleSchema.nullish(),
    PriceCatalogue: PriceSchema.nullable(),
    PriceDistributor: PriceSchema.nullable(),
    Type: z.nativeEnum(ItemType),
});

export type CountryCode = z.infer<typeof CountryCodeSchema>;
export type LanguageCode = z.infer<typeof LanguageCodeSchema>;
export type CurrencyCode = z.infer<typeof CurrencyCodeSchema>;

export type LocalizedValue = z.infer<typeof LocalizedValueSchema>;
export type LocalizedArray = z.infer<typeof LocalizedArraySchema>;

export type OrderLink = z.infer<typeof OrderLinkSchema>;
export type Price = z.infer<typeof PriceSchema>;

export type AppUserSimple = z.infer<typeof AppUserSimpleSchema>;
export type PartnerSimple = z.infer<typeof PartnerSimpleSchema>;

export type CategorySimple = z.infer<typeof CategorySimpleSchema>;
export type CategoryItemDetail = z.infer<typeof CategoryItemDetailSchema>;
